const LAUNCH_PARAMS_KEY = 'launchParams'

const PARAM_KEYS = ['utm_campaign', 'utm_content', 'adset_id', 'ad_ids', 'ad_id', 'placement', 'plan']

function parseChargeLevel(chargeLevel) {
  try {
    let str = chargeLevel
    try {
      str = decodeURIComponent(chargeLevel)
    } catch (e) {
      // already decoded
    }
    const arr = JSON.parse(str)
    if (!Array.isArray(arr)) return {}
    const result = {}
    for (const item of arr) {
      if (item.subscription !== undefined) {
        result.subscription = String(item.subscription)
      }
      if (item.purchase !== undefined) {
        result.purchase = String(item.purchase)
      }
      if (item.coin_count !== undefined) {
        result.coin_count = String(item.coin_count)
      }
      if (item.priority !== undefined) {
        result.priority = String(item.priority)
      }
    }
    return result
  } catch (e) {
    console.warn('parseChargeLevel: invalid charge_level format')
    return {}
  }
}

export function registerLaunchParams() {
  try {
    let query = {}

    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search)
      query = Object.fromEntries(urlParams.entries())
    }

    if (!Object.keys(query).length) return

    const params = {}

    PARAM_KEYS.forEach(key => {
      if (query[key]) {
        params[key] = query[key]
      }
    })

    if (query.charge_level) {
      let chargeLevel = query.charge_level
      try {
        chargeLevel = decodeURIComponent(chargeLevel)
      } catch (e) {
        // already decoded
      }
      params.charge_level = chargeLevel
      const chargeInfo = parseChargeLevel(query.charge_level)
      Object.assign(params, chargeInfo)
    }

    if (Object.keys(params).length) {
      sessionStorage.setItem(LAUNCH_PARAMS_KEY, JSON.stringify(params))
    }
  } catch (e) {
    console.error('registerLaunchParams error', e)
  }
}

export function getLaunchParams() {
  try {
    const raw = sessionStorage.getItem(LAUNCH_PARAMS_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch (e) {
    return {}
  }
}

export function getSetId() {
  return getLaunchParams().plan || ''
}

export function getChargeLevel() {
  return getLaunchParams().charge_level || ''
}
